import React, {useEffect, useRef} from "react";
import {MedicationSummary} from "./types";
import MedicationSummaryCard from "./medication-summary-card/medication-summary-card";
import './index.scss';
import './medication-swiper.scss';
import 'swiper/css/bundle';
import InitialContext from "../../../state/static-data/InitialContext";
import {register} from 'swiper/element/bundle';

register();

const MedicationSummaryWidget = () => {
    const swiperElRef = useRef(null);
    const medicationSummarySwiperSlideCards: any = [];

    let medicationSummaries: MedicationSummary[];
    const medicationSummaryWidgetAttributes = InitialContext.getMedicationSummaryWidgetAttributes();
    if (!!medicationSummaryWidgetAttributes.medicationSummaryList) {
        medicationSummaries = medicationSummaryWidgetAttributes.medicationSummaryList;
        medicationSummaries.forEach((medicationSummary, index) => {
            medicationSummarySwiperSlideCards.push(
                <swiper-slide key={`medicationSummary-${index}`}><MedicationSummaryCard medicationSummary={medicationSummary}/></swiper-slide>
            );
        });
    }

    useEffect(() => {
        const swiperContainer: any = swiperElRef.current;
        const params = {
            a11y: true,
            slidesPerView: "auto",
            spaceBetween: 10,
            breakpoints: {
                945: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            },
            keyboard: {
                enabled: true
            },
            pagination: {
                clickable: true,
            },
        }

        Object.assign(swiperContainer, params);
        swiperContainer.initialize();
    }, [])

    return (
        <>
            {/*Don't use pui-section, it doesn't work well with swiper web components*/}
            <div className="medication-summary-carousel-widget">
                <swiper-container ref={swiperElRef} init="false">
                    {medicationSummarySwiperSlideCards}
                </swiper-container>
            </div>
        </>
    )
}

export default MedicationSummaryWidget;